// Hook transversal (§6.2): difiere un valor N ms — típico para búsquedas server-side, evita
// disparar una query por tecla. Sin negocio, sin dependencias.
import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delayMs = 300): T {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => {
            setDebounced(value);
        }, delayMs);
        return () => {
            clearTimeout(id);
        };
    }, [value, delayMs]);
    return debounced;
}
